import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage"

import { storage } from "./storage"

interface IUploadPayload {
  file: File
  path: string
  onUpload: (downloadUrl: string) => void
}

export const uploadStorage = (payload: IUploadPayload) => {
  const spaceRef = ref(storage, payload.path)
  const uploadTask = uploadBytesResumable(spaceRef, payload.file)
  uploadTask.on(
    "state_changed",
    (snapshot) => {
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      console.log("Upload is " + progress + "% done")
      switch (snapshot.state) {
        case "paused":
          console.log("Upload is paused")
          break
        case "running":
          console.log("Upload is running")
          break
      }
    },
    (error) => {
      // FIXME: エラー処理追加
      console.warn(error)
    },
    () => {
      getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
        console.log("File available at", downloadURL)
        payload.onUpload(downloadURL)
      })
    },
  )
}
